import { render, staticRenderFns } from "./FriendshipActivities.vue?vue&type=template&id=93a7bf6a&scoped=true"
import script from "./FriendshipActivities.vue?vue&type=script&lang=ts"
export * from "./FriendshipActivities.vue?vue&type=script&lang=ts"
import style0 from "./FriendshipActivities.vue?vue&type=style&index=0&id=93a7bf6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a7bf6a",
  null
  
)

export default component.exports